/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateScheduledNotificationDto } from '../models/CreateScheduledNotificationDto';
import type { ScheduledNotificationDto } from '../models/ScheduledNotificationDto';
import type { UpdateScheduledNotificationDto } from '../models/UpdateScheduledNotificationDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ScheduledNotificationsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Create a push notification to all patients, sent once or weekly
     * @param requestBody
     * @returns ScheduledNotificationDto
     * @throws ApiError
     */
    public create(
        requestBody: CreateScheduledNotificationDto,
    ): CancelablePromise<ScheduledNotificationDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/scheduled-notifications',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * List scheduled notifications, newest first
     * @returns ScheduledNotificationDto
     * @throws ApiError
     */
    public findAll(): CancelablePromise<Array<ScheduledNotificationDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/scheduled-notifications',
        });
    }

    /**
     * Get a scheduled notification
     * @param id
     * @returns ScheduledNotificationDto
     * @throws ApiError
     */
    public findById(
        id: string,
    ): CancelablePromise<ScheduledNotificationDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/scheduled-notifications/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Update a scheduled notification. A new schedule replaces the old one as a whole.
     * @param id
     * @param requestBody
     * @returns ScheduledNotificationDto
     * @throws ApiError
     */
    public update(
        id: string,
        requestBody: UpdateScheduledNotificationDto,
    ): CancelablePromise<ScheduledNotificationDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/scheduled-notifications/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete a scheduled notification and cancel its unsent pushes
     * @param id
     * @returns any
     * @throws ApiError
     */
    public delete(
        id: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/scheduled-notifications/{id}',
            path: {
                'id': id,
            },
        });
    }

}
